import { useEffect } from 'react';

const ENV_PREFIX =
  import.meta.env.MODE === 'development'
    ? '[DEV] '
    : import.meta.env.MODE === 'test'
      ? '[TEST] '
      : '';

export function useDocumentTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${ENV_PREFIX}${title} | Kiku`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
